//@ts-expect-error there is not a type declaration for this module yet.
import { parse as parseSDF } from 'sdf-parser';
import { readMolfileText } from './readMolfile';
export async function readSDF(file, options = {}) {
    const { logger, mixedEOL } = options;
    const { molecules } = parseSDF(await file.text(), { mixedEOL });
    const result = {
        molecules: [],
        spectra: [],
    };
    for (const { molfile } of molecules) {
        const { molecules = [] } = readMolfileText(molfile);
        result.molecules.push(...molecules);
    }
    if (logger) {
        logger[result.molecules.length > 0 ? 'info' : 'debug'](`Loaded ${result.molecules.length} molecules from the ${file.name} file`);
    }
    return result;
}
//# sourceMappingURL=readSDF.js.map